import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'
import classnames from 'classnames'
import { showModal } from 'actions/common'
import LoadingSpinner from 'components/loading-spinner'
import { VOUCHER_EDIT_MODAL } from 'constants/modal-constants'
import { loadSetupform /* , updateSetupformAdvancedDetails */ } from 'actions/setupform'
import SetupformBreadcrumbProgress, { BREADCRUMB_VOUCHERS } from 'components/setupform-breadcrumb-progress'
import ErrorMessage from 'components/error-message'
import { push } from 'react-router-redux'
import { getSetupformUrl, getPartnerUrl } from 'utils/urls'
import { getSetupform } from 'selectors/entities'
import { STAGE_STATUS } from 'constants/setupform-constants'
import SetupformVouchersForm from 'components/setupform-vouchers-form/setupform-vouchers-form-container'
import {
  addNewVoucher,
  startCopyingVoucher,
  startDeletingVoucher
} from 'actions/setupform-voucher/setupform-voucher-actions'
import { showErrorMessage } from 'actions/common/common-actions'
import SetupformVouchersModal from './setupform-vouchers-modal'
import styles from '../setupform-page/setupform-page.css'
import TimeOutLogo from '../../../assets/icons/to-logo-black.svg'
import ArrowRightIcon from '../../../assets/icons/arrow-right.svg'
import VoucherRow from './voucher-row'

export class SetupformVouchersPage extends Component {

  constructor(props) {
    super(props)

    this.handleNextClick = () => {
      if (this.props.vouchers.length === 0) {
        this.props.showVouchersMissingError()
      } else {
        this.props.onNextClick(this.props.partnerId, this.props.setupformId)
      }
    }

    this.handleAddNewVoucher = () => {
      this.addNewFormRef.submit()
    }

    this.onFormSubmit = (values, dispatch) => {
      dispatch(addNewVoucher(
        this.props.setupformId,
        values
      ))
    }
  }

  componentWillMount() {
    this.props.loadSetupform(this.props.setupformId)
  }

  renderVouchers() {
    if (this.props.vouchers.length === 0) {
      return (
        <tr>
          <td colSpan="3">
            No vouchers have been created for this product yet.
          </td>
        </tr>
      )
    }

    return this.props.vouchers.map(v => <VoucherRow
      voucher={v}
      key={v.instanceGroupId}
      setupformId={this.props.setupformId}
      currencyCode={this.props.currencyCode}
      onEditClick={this.props.onVoucherEditClick}
      onCopyClick={this.props.onVoucherCopyClick}
      onDeleteClick={this.props.onVoucherDeleteClick}
    />)
  }

  renderPage() {
    return (
      <RelayoutWrapper>
        <Relayout align="center">
          <RelayoutItem sm="10">
            <div>
              <h3>Voucher details</h3>
              <p>Enter the details for the different vouchers that belong to this product.</p>
              <table styleName="voucher-table">
                <thead>
                  <tr>
                    <th>Voucher name</th>
                    <th>Valid dates</th>
                    <th>Sales dates</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.renderVouchers()}
                </tbody>
              </table>
            </div>
          </RelayoutItem>
          <RelayoutItem sm="10">
            <h3 styleName="extra-space">Add a new voucher</h3>
            <SetupformVouchersForm
              onSubmit={this.onFormSubmit}
              ref={(c) => { this.addNewFormRef = c }}
              setupformId={this.props.setupformId}
              instanceGroupId="new"
            />
          </RelayoutItem>
          <RelayoutItem sm="10">
            <button
              disabled={false}
              styleName={classnames('form-button')}
              onClick={this.handleAddNewVoucher}
            >
              Add voucher
            </button>
          </RelayoutItem>
        </Relayout>
      </RelayoutWrapper>
    )
  }

  render() {
    return (
      <DocumentTitle title={'Ecommerce Portal - Time Out - Setupform'}>
        <div styleName="page">

          <div styleName="header">
            <a href={getPartnerUrl(this.props.partnerId)}>
              <div styleName="logo">
                <TimeOutLogo styleName="logo-icon" />
              </div>
            </a>
            <SetupformBreadcrumbProgress
              isVoucher
              currentStep={BREADCRUMB_VOUCHERS}
            />
            <button
              disabled={this.props.submitting}
              styleName={classnames('next', { 'next-submitting': this.props.submitting })}
              onClick={this.handleNextClick}
            >
              Next <ArrowRightIcon styleName="next-icon" />
            </button>
          </div>

          <ErrorMessage isFixed isSmall />

          { this.props.vouchers
            ? this.renderPage()
            : <LoadingSpinner />
          }

          <SetupformVouchersModal />
        </div>
      </DocumentTitle>
    )
  }

}

SetupformVouchersPage.propTypes = {
  loadSetupform: PropTypes.func,
  partnerId: PropTypes.string,
  setupformId: PropTypes.string,
  submitting: PropTypes.bool,
  vouchers: PropTypes.array,
  onNextClick: PropTypes.func,
  onVoucherEditClick: PropTypes.func,
  onVoucherCopyClick: PropTypes.func,
  onVoucherDeleteClick: PropTypes.func,
  showVouchersMissingError: PropTypes.func,
  currencyCode: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const { setupformId } = ownProps.params
  const setupform = getSetupform(setupformId)(state)
  return {
    ...ownProps.params,
    setupFormId: setupformId,
    submitting: state.form.setupform && state.form.setupform._submitting, // eslint-disable-line no-underscore-dangle
    currencyCode: setupform && setupform.currencyCode,
    vouchers: setupform
      ? setupform.instanceGroups.map(
          instanceGroup => ({
            instanceGroupId: instanceGroup.id,
            voucherName: (instanceGroup.instances[0] && instanceGroup.instances[0].ticketType) || 'Unknown',
            voucherQuantity: instanceGroup.ticketCount,
            initialPrice: instanceGroup.instances[0].initialPrice,
            discountPrice: instanceGroup.instances[0].discountPrice,
            onsaleTime: instanceGroup.instances[0].onsaleTime,
            offsaleTime: instanceGroup.instances[0].offsaleTime,
            voucherValidFrom: instanceGroup.instances[0].voucherValidFrom,
            voucherValidTo: instanceGroup.instances[0].voucherValidTo,
            commission: instanceGroup.instances[0].commission,
          })
        )
      : null
  }
}

// We use dispatch here, as we need to be able to pass different arguments to the getSetupformUrl
// and showModal action creators
const mapDispatchToProps = dispatch => ({
  loadSetupform: id => dispatch(loadSetupform(id)),
  showVouchersMissingError: () => dispatch(showErrorMessage('Please add at least one voucher')),
  onNextClick: (partnerId, setupformId) => dispatch(
    push(getSetupformUrl(partnerId, setupformId, STAGE_STATUS.SUMMARY))
  ),
  onVoucherEditClick: (setupformId, instanceGroupId) => dispatch(
    showModal(VOUCHER_EDIT_MODAL, { setupformId, instanceGroupId })
  ),
  onVoucherCopyClick: (setupformId, instanceGroupId) => dispatch(startCopyingVoucher(setupformId, instanceGroupId)),
  onVoucherDeleteClick: (setupformId, instanceGroupId) => dispatch(startDeletingVoucher(setupformId, instanceGroupId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(SetupformVouchersPage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/setupform-vouchers-page/setupform-vouchers-page.js
 **/